exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".highlighted[data-v-1ea03295] {\n  font-weight: bold;\n}\n.clipped[data-v-1ea03295] {\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 100%;\n  text-overflow: ellipsis;\n}\n", ""]);

// exports
